import { Spinner } from './spinner';
import { ReactNode } from 'react';

export type AnimatedIcon = 'spinner';
export const AnimatedIcons: { [key in AnimatedIcon]: ReactNode } = {
  spinner: Spinner,
};
